<template>
    <div class="p-3">
        <el-card header="Eventos">
            <ElForm ref="formRef" label-position="top" inline :model="searchData">
                <!-- <ElFormItem label="Viagens da empresa" class="col-12 col-md-4 col-lg-3" prop="q">
                    <ElSelect :clearable="true" filterable :loading="loading" name="travel_company_id" v-model="searchData.travel_company_id">
                        <ElOption :value="0" :key="0" :label="'Todas Transportadoras'"></ElOption>
                        <ElOption v-for="company in companies" :key="(company.id as number)" :value="(company.id as number)" :label="company.name"></ElOption>
                    </ElSelect>
                </ElFormItem> -->
                <ElFormItem label="Datas das viagens" class="col-12 col-md-5 col-lg-4" prop="dates">
                    <ElDatePicker type="daterange" range-separator="-" start-placeholder="Desde" end-placeholder="Até" v-model="searchData.dates" />
                </ElFormItem>

                <ElFormItem label="buscar">
                    <ElButton :loading="loading" type="primary" @click="search">Procurar viagens</ElButton>
                </ElFormItem>
            </ElForm>
            <PersonalTable :loading="loading" :height="400" :showRows="10" :cols="[
                {label: 'Cod', prop: 'id'},
            ]" :data="trips" >
                <el-table-column label="Data e hora de partida" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ new Date(data.row.departure).toLocaleString("af") }}
                        <ElTag :type="new Date(data.row.departure) < new Date() ? 'danger':'success'">{{ new Date(data.row.departure) < new Date() ? 'Realizada':'Disponivel' }}</ElTag>
                    </template>
                </el-table-column>
                <el-table-column label="Empresa" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.car.travel_company.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Carro" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.car.name }} [{{ data.row.car.plate }}]
                    </template>
                </el-table-column>
                <el-table-column label="Rota de viagem" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.route.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Acções" class-name="auto" :min-width="150">
                    <template #default="data">
                        <span class="p-2">
                            <el-button type="primary" tag="router-link" :to="'/travel/' + data.row.id" icon="View" title="Ver mais"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PersonalTable>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount, reactive, ref } from 'vue'
    import { ElMessageBox, ElForm, ElFormItem, ElDatePicker, ElButton, FormInstance, ElSelect, ElTag } from 'element-plus';
    import { Travel, TravelCompany } from '@/services/types';

    const loading = ref<boolean>(true)
    const trips = ref<Array<Travel>>([])
    const companies = ref<Array<TravelCompany>>([])
    const formRef = ref<FormInstance>()

    const searchData = reactive<{travel_company_id: number, dates: Array<string>}>({travel_company_id: 0, dates: []})

    const getCompanies = async () => {
        const res = await Api.get(`admin/travel-companies`)
        if (res.status == 200) {
            console.log(res.data)
            companies.value = res.data.companies
        } else {
            console.log(res)
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }
    
    const getTrips = async (id: number | false | null = 0, dates: Array<string> | undefined | false = false) => {
        const params = new URLSearchParams()
        if (id && id > 0) {
            params.append('travel_company_id', id.toString())
        } 
        if (dates) {
            params.append('start', new Date(dates[0]).toISOString())
            params.append('end', new Date(dates[1]).toISOString())
        }
        const res = await Api.get(`admin/travel?${params.toString()}`)
        if (res.status == 200) {
            console.log(res)
            trips.value = res.data.travel
        } else {
            console.log(res)
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }

    const search = async () => {
        loading.value = true
        await getTrips(searchData.travel_company_id, searchData.dates)
        loading.value = false
    }
    
    onBeforeMount(async () => {
        loading.value = true
        await Promise.all([
            getTrips(),
            getCompanies()
        ])
        loading.value = false
    })
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
